import React from 'react';
import './RadialGradientComponent.css';

const TCBackground = () => {
  return (
    <img src="/TC.png" alt="" className='bgimgimg'/>
  );
};

export default TCBackground;
